import { cn } from '@/lib/utils';

/**
 * The Falcon mark. The glyph occupies roughly the middle 40% of its box
 * (strokes span x 8.9–20.5 of a 30 viewBox), so callers that need the visible
 * shape flush with an edge pull it back by ~0.3 × size.
 */
export default function LogoIcon({
  size = 24,
  color = 'black',
  className,
}: {
  size?: number;
  color?: string;
  className?: string;
}) {
  return (
    <div className={cn('flex items-center', className)}>
      <svg width={size} height={size} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.2495 8.90137L13.1437 20.4925" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M20.492 13.144L8.90119 16.2499" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M10.4541 10.4543L18.9391 18.9395" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
  );
}
